import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Global error handler for script errors (like browser extensions)
window.addEventListener('error', (event) => {
  // Suppress "Script error" messages that are common with browser extensions
  if (event.error && event.error.toString() === 'Script error.') {
    console.warn('Browser extension script error suppressed');
    event.preventDefault();
    return false;
  }
});

// Suppress unhandled promise rejections from browser extensions
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.toString() === 'Script error.') {
    console.warn('Browser extension script error suppressed (unhandled rejection)');
    event.preventDefault();
    return false;
  }
});

// Prevent context menu on right-click to avoid potential script errors
document.addEventListener('contextmenu', (event) => {
  // Only prevent default in development mode or if explicitly needed
  if (process.env.NODE_ENV === 'development') {
    console.warn('Context menu prevented in development mode');
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
); 